import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Img, Prose, DemoBadge } from "@/components/common";
import ShareBar from "@/components/ShareBar";
import NotFound from "@/pages/NotFound";
import useTitle from "@/lib/useTitle";
import { fmtDay } from "@/lib/time";

export default function Noticia() {
  const { slug } = useParams();
  const { data } = useSite();
  const n = data.news.find((x) => x.slug === slug);
  useTitle(n?.title || "Notícia");
  if (!n) return <NotFound />;
  return (
    <article className="container-x py-10 max-w-4xl" data-testid="news-page">
      <Link to="/noticias" className="inline-flex items-center gap-2 text-sm font-semibold min-h-[44px]"><ArrowLeft className="h-4 w-4" aria-hidden />Notícias</Link>
      <p className="eyebrow text-slate-500 mt-6">{fmtDay(n.date, false)}</p>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold leading-[0.95] mt-2" data-testid="news-title">{n.title}</h1>
      <DemoBadge show={n.demo} className="mt-3" />
      <Img src={n.image} alt="" className="mt-8 rounded-3xl aspect-[16/9] w-full object-cover" />
      <Prose text={n.body} className="mt-8 text-base md:text-lg" />
      <div className="mt-10"><ShareBar title={n.title} path={`/noticias/${n.slug}`} /></div>
    </article>
  );
}
